import React from 'react';
import { Button, SimpleCell } from '@vkontakte/vkui';

export function PrimaryButton({ children, onClick, disabled = false, secondary = false, className = '' }) {
  return (
    <Button
      size="l"
      mode={secondary ? 'secondary' : 'primary'}
      stretched={className.includes('w-full')}
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}

export function HeaderActionButton({ icon, children, onClick, secondary = false }) {
  return (
    <SimpleCell before={icon} onClick={onClick} Component="button" disabled={secondary ? false : undefined}>
      {children}
    </SimpleCell>
  );
}
